import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import resourceSubject from '../reactivity/resource-subject';

Component('tr-project-list-view-trigger', {
  ready() {
    console.debug('trigger project_list_view_show');
    $(() => {
      resourceSubject('user-guide').next('project_list_view_show', {});
    });
  },
  beforeCache() {
    this.remove();
  },
});
